// extracted by mini-css-extract-plugin
export default {"panel":"styles__panel--vnLPj","close-button":"styles__close-button--kmOk2","content":"styles__content--MR845","footer":"styles__footer--nJSvU"};